import { render } from "./new-request.vue?vue&type=template&id=548705be"
import script from "./new-request.vue?vue&type=script&lang=js"
export * from "./new-request.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__